
import { Services } from '../components/Services';

export function ServicesPage() {
    return (
        <div className="min-h-screen">
            {/* Services Section */}
            <div className="pt-20">
                <Services />
            </div>
        </div>
    );
}
